<template>
    <div class="ls-address-sidebar">
        <ls-address-row></ls-address-row>
        <ls-google-map
            :address="address.googlePlace.formatted_address"
            :lat="address.googlePlace.lat"
            :lng="address.googlePlace.lng"
        >
        </ls-google-map>
        <ls-zillow-drawer></ls-zillow-drawer>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import lsAddressRow from '@/components/original-mydot/address-row/AddressRow.vue';
import lsGoogleMap from '@/components/original-mydot/google-components/GoogleMap.vue';
import lsZillowDrawer from '@/components/original-mydot/zillow-drawer/ZillowDrawer.vue';

export default {
    components: {
        lsAddressRow,
        lsGoogleMap,
        lsZillowDrawer,
    },
    computed: {
        ...mapState(['address']),
    },
};
</script>

<style lang="scss" scoped></style>
